export default "__VITE_ASSET__DpY3w40Y__"